import { useReactiveVar } from '@apollo/client/react';
import { Visitor } from 'graphql/generated/graphqlTypes';
import { Translation } from 'hooks/useTranslation/useTranslation';
import { isEqual, orderBy } from 'lodash';
import { useEffect, useState } from 'react';
import { setInstallersGroupsAction } from 'state/actions/installersGroups';
import { installersGroupsVar } from 'state/vars';

interface Sorting {
  isAscending?: boolean;
  columnName?: string;
}

export const handleSorting = (translation: Translation, item: Visitor, columnName?: string) => {
  switch (columnName) {
    case translation.atlas_config_app:
      return !item.mobileDevices.find(({ role, isRegistered }) => role === 'CONFIG' && isRegistered)?.isRegistered;
    case translation.atlas_access_app:
      return !item.mobileDevices.find(({ role, isRegistered }) => role === 'ACCESS' && isRegistered)?.isRegistered;
    case translation.installer:
    default:
      return item.name;
  }
};

export const getSortedArray = (translation: Translation, installersMembers: Visitor[], sorting: Sorting) =>
  orderBy(installersMembers, (item) => handleSorting(translation, item, sorting.columnName as string), [
    sorting.isAscending ? 'asc' : 'desc'
  ]);

const useSortingInstallersTable = (translation: Translation) => {
  const installers = useReactiveVar(installersGroupsVar);
  const [sorting, setSorting] = useState<Sorting>({ isAscending: true, columnName: translation.installer });

  const handleSortingOnClick = (columnName: string) => {
    if (sorting.isAscending !== undefined && sorting.columnName === columnName) {
      return setSorting({ isAscending: !sorting.isAscending, columnName });
    }
    return setSorting({ isAscending: true, columnName });
  };

  const handleSortingIcon = (columnName: string) => {
    if (sorting.isAscending !== undefined)
      if (sorting.columnName === columnName) return sorting.isAscending ? 'ArrowUpSorting' : 'ArrowDownSorting';
    return undefined;
  };

  useEffect(() => {
    const sortedInstallersGroups = installers.map((group) => ({
      ...group,
      members: getSortedArray(translation, group.members, sorting)
    }));
    if (!isEqual(sortedInstallersGroups, installers)) setInstallersGroupsAction(sortedInstallersGroups);
  }, [installers, sorting, translation]);

  return { handleSortingOnClick, handleSortingIcon };
};

export default useSortingInstallersTable;
